import { render, staticRenderFns } from "./FormTableAdjustment.vue?vue&type=template&id=63c78feb&"
import script from "./FormTableAdjustment.vue?vue&type=script&lang=ts&"
export * from "./FormTableAdjustment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63c78feb')) {
      api.createRecord('63c78feb', component.options)
    } else {
      api.reload('63c78feb', component.options)
    }
    module.hot.accept("./FormTableAdjustment.vue?vue&type=template&id=63c78feb&", function () {
      api.rerender('63c78feb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StockAdjustment/FormTableAdjustment.vue"
export default component.exports